var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73337 11.2667C6.66671 11.2667 6.60004 11.2001 6.53337 11.1334L3.86671 8.46675C3.60004 8.20008 3.60004 7.80008 3.86671 7.53341C4.13337 7.26675 4.53337 7.26675 4.80004 7.53341L6.33337 9.06675V1.33341C6.33337 0.933415 6.60004 0.666748 7.00004 0.666748C7.40004 0.666748 7.66671 0.933415 7.66671 1.33341V9.06675L9.20004 7.53341C9.46671 7.26675 9.86671 7.26675 10.1334 7.53341C10.4 7.80008 10.4 8.20008 10.1334 8.46675L7.46671 11.1334C7.43337 11.1667 7.40004 11.1834 7.36671 11.2001C7.33337 11.2167 7.30004 11.2334 7.26671 11.2667C7.20004 11.3334 7.06671 11.3334 7.00004 11.3334C6.93337 11.3334 6.80004 11.3334 6.73337 11.2667ZM13.6667 13.3334V11.3334C13.6667 10.9334 13.4 10.6667 13 10.6667C12.6 10.6667 12.3334 10.9334 12.3334 11.3334V13.3334C12.3334 13.7334 12.0667 14.0001 11.6667 14.0001H2.33337C1.93337 14.0001 1.66671 13.7334 1.66671 13.3334V11.3334C1.66671 10.9334 1.40004 10.6667 1.00004 10.6667C0.600041 10.6667 0.333374 10.9334 0.333374 11.3334V13.3334C0.333374 14.4667 1.20004 15.3334 2.33337 15.3334H11.6667C12.8 15.3334 13.6667 14.4667 13.6667 13.3334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.111c272f2927aa914ab4678ceafec064.svg";
export { ForwardRef as ReactComponent };